"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarkerQuadrilaterals = void 0;
const retrommo_types_1 = require("retrommo-types");
const pixel_pigeon_1 = require("pixel-pigeon");
const getConstants_1 = require("./getConstants");
const constants_1 = require("../constants");
const getMarkerQuadrilaterals = (color) => {
    const constants = (0, getConstants_1.getConstants)();
    const entityQuadrilaterals = [];
    const startTime = (0, pixel_pigeon_1.getCurrentTime)();
    const condition = () => {
        const diff = (0, pixel_pigeon_1.getCurrentTime)() - startTime;
        const amount = diff % (constants_1.markerDuration * 2);
        return amount < constants_1.markerDuration;
    };
    entityQuadrilaterals.push({
        condition,
        quadrilateralID: (0, pixel_pigeon_1.createQuadrilateral)({
            color: retrommo_types_1.Color.Black,
            height: 1,
            width: constants["tile-size"] + 8,
        }),
        x: -4,
        y: -4,
    });
    entityQuadrilaterals.push({
        condition,
        quadrilateralID: (0, pixel_pigeon_1.createQuadrilateral)({
            color: retrommo_types_1.Color.Black,
            height: constants["tile-size"] + 6,
            width: 1,
        }),
        x: 19,
        y: -3,
    });
    entityQuadrilaterals.push({
        condition,
        quadrilateralID: (0, pixel_pigeon_1.createQuadrilateral)({
            color: retrommo_types_1.Color.Black,
            height: 1,
            width: constants["tile-size"] + 8,
        }),
        x: -4,
        y: 19,
    });
    entityQuadrilaterals.push({
        condition,
        quadrilateralID: (0, pixel_pigeon_1.createQuadrilateral)({
            color: retrommo_types_1.Color.Black,
            height: constants["tile-size"] + 6,
            width: 1,
        }),
        x: -4,
        y: -3,
    });
    entityQuadrilaterals.push({
        condition,
        quadrilateralID: (0, pixel_pigeon_1.createQuadrilateral)({
            color: retrommo_types_1.Color.Black,
            height: 1,
            width: constants["tile-size"] + 4,
        }),
        x: -2,
        y: -2,
    });
    entityQuadrilaterals.push({
        condition,
        quadrilateralID: (0, pixel_pigeon_1.createQuadrilateral)({
            color: retrommo_types_1.Color.Black,
            height: constants["tile-size"] + 2,
            width: 1,
        }),
        x: 17,
        y: -1,
    });
    entityQuadrilaterals.push({
        condition,
        quadrilateralID: (0, pixel_pigeon_1.createQuadrilateral)({
            color: retrommo_types_1.Color.Black,
            height: 1,
            width: constants["tile-size"] + 4,
        }),
        x: -2,
        y: 17,
    });
    entityQuadrilaterals.push({
        condition,
        quadrilateralID: (0, pixel_pigeon_1.createQuadrilateral)({
            color: retrommo_types_1.Color.Black,
            height: constants["tile-size"] + 2,
            width: 1,
        }),
        x: -2,
        y: -1,
    });
    entityQuadrilaterals.push({
        condition,
        quadrilateralID: (0, pixel_pigeon_1.createQuadrilateral)({
            color,
            height: 1,
            width: constants["tile-size"] + 6,
        }),
        x: -3,
        y: -3,
    });
    entityQuadrilaterals.push({
        condition,
        quadrilateralID: (0, pixel_pigeon_1.createQuadrilateral)({
            color,
            height: constants["tile-size"] + 4,
            width: 1,
        }),
        x: 18,
        y: -2,
    });
    entityQuadrilaterals.push({
        condition,
        quadrilateralID: (0, pixel_pigeon_1.createQuadrilateral)({
            color,
            height: 1,
            width: constants["tile-size"] + 6,
        }),
        x: -3,
        y: 18,
    });
    entityQuadrilaterals.push({
        condition,
        quadrilateralID: (0, pixel_pigeon_1.createQuadrilateral)({
            color,
            height: constants["tile-size"] + 4,
            width: 1,
        }),
        x: -3,
        y: -2,
    });
    return entityQuadrilaterals;
};
exports.getMarkerQuadrilaterals = getMarkerQuadrilaterals;
